/**
 * App 的歌單與加入位置共用原生對話框，交由瀏覽器管理焦點、Escape 與背景隔離。
 * 僅控制介面開關，不修改歌曲資料；關閉後焦點回到原本的操作位置。
 */
import { useEffect, useRef } from "react";

export default function Modal({ children, className = "", label, onClose }) {
  const ref = useRef(null);
  useEffect(() => {
    const dialog = ref.current;
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = "hidden";
    return () => {
      dialog.close();
      document.body.style.overflow = previousOverflow;
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, []);
  return (
    <dialog ref={ref} className={`modal ${className}`} aria-label={label}
      onCancel={(event) => { event.preventDefault(); onClose(); }}
      onClick={(event) => { if (event.target === event.currentTarget) onClose(); }}>
      <div className="modal-content">{children}</div>
    </dialog>
  );
}
